module.exports = __webpack_public_path__ + "img/img_pokemon_js.75f2790f.jpg";